<template>
  <section :class="[backgroundClasses, 'faq', '!pt-[50px]', '!pb-[150px]']">
    <h2
      v-if="content.title"
      class="font-title uppercase mb-[40px] text-[40px] leading-[38px] whitespace-break-spaces relative text-center mt-[100px] lg:text-[115px] lg:leading-[102px] lg:mt-[150px]"
      v-reveal
    >
      {{ content.title }}
    </h2>

    <p v-if="content.description" class="relative mb-[37px] text-center" v-reveal="{ delay: 250 }">
      {{ content.description }}
    </p>

    <nav class="flex flex-col mb-[55px] lg:hidden">
      <RouterLink
        v-for="(section, i) in content.subtitles"
        :key="section.flexKey"
        :to="{
          name: $route.name,
          hash: `#faq-${section.flexKey}`,
        }"
        v-reveal="{ delay: 200 + 50 * i }"
        active-class=""
        exact-active-class=""
        class="font-title w-full py-[9px] flex items-center justify-between gap-[15px] text-burgundy! hover:text-burgundy! no-underline uppercase text-[14px] leading-[1.05] border-b border-burgundy/65 bg-transparent! hover:bg-transparent!"
      >
        <span>
          {{ section.subtitle }}
        </span>

        <span class="shrink-0 font-[initial] text-[17px] leading-none font-normal"> → </span>
      </RouterLink>
    </nav>

    <nav
      class="hidden lg:flex items-center justify-center flex-wrap gap-[40px] py-[20px] mb-[70px]"
    >
      <RouterLink
        v-for="(section, i) in content.subtitles"
        :key="section.flexKey"
        :to="{
          name: $route.name,
          hash: `#faq-${section.flexKey}`,
        }"
        v-reveal="{ delay: 200 + 50 * i }"
        active-class=""
        exact-active-class=""
        class="font-title shrink-0 text-burgundy! hover:text-burgundy! no-underline uppercase text-[18px] leading-[1.2] pb-[8px] border-b border-transparent bg-transparent! hover:bg-transparent! transition-[border-color] duration-300 hover:border-burgundy!"
      >
        {{ section.subtitle }}
      </RouterLink>
    </nav>

    <div
      v-for="section in content.subtitles"
      :key="section.flexKey"
      :id="`faq-${section.flexKey}`"
      class="relative mb-[80px] last:mb-0 lg:mb-[120px]"
    >
      <h3
        class="font-title uppercase text-[28px] leading-[1.1] mb-[30px] lg:text-[45px] lg:mb-[40px]"
        v-reveal="{ delay: 350 }"
      >
        {{ section.subtitle }}
      </h3>

      <div class="w-full">
        <FaqCard
          v-for="(card, i) in section.cards"
          :key="card.flexKey"
          :content="card"
          v-reveal="{ delay: 300 + 50 * i }"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import FaqCard from '@/components/cards/FaqCard.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'FaqSection',

  components: {
    FaqCard,
  },

  props: {
    content: {
      type: Object as PropType<any>,
      required: true,
    },
  },

  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
}
</script>
